export const NAVIGATION__BTN__GO_PREMIUM = {
    type: 'button',
    context: '',
    name: 'go-premium',
    position: 'navigation-bar',
};

export const NAVIGATION__BTN__LOGIN = {
    type: 'button',
    context: 'press,support,login',
    name: 'login',
    position: 'navigation-bar',
};

export const NAVIGATION__LINK__SUPPORT = {
    type: 'link',
    context: '',
    name: 'support',
    position: 'navigation-bar',
};

export const NAVIGATION__LINK__DOWNLOAD = {
    type: 'link',
    context: '',
    name: 'download',
    position: 'navigation-bar',
};

export const NAVIGATION__LINK__DROPDOWN_ITEMS = {
    type: 'link',
    context: '',
    position: 'navigation-bar-dropdown',
};

export const NAVIGATION__BTN__LOGOUT = {
    type: 'button',
    context: '',
    name: 'logout',
    position: 'navigation-bar-dropdown',
};

export const DASHBOARD_GIFTS__BTN__VIEW_MORE = {
    type: 'button',
    context: '',
    name: 'view-more-purchased-gifts',
    position: 'dashboard-purchased-gift',
};

export const DASHBOARD__LINK__CANCEL_SUBSCRIPTION = {
    type: 'link',
    context: '',
    name: 'cancel-subscription',
    position: 'dashboard-subscription',
};

export const DASHBOARD__BTN__UPGRADE = {
    type: 'button',
    context: '',
    name: 'change-subscription',
    position: 'dashboard-subscription',
};

export const DASHBOARD__BTN__RESUBSCRIBE = {
    type: 'button',
    context: '',
    name: 'resubscribe',
    position: 'dashboard-subscription',
};

export const DASHBOARD__LINK__GO_TO_ITUNES = {
    type: 'link',
    context: '',
    name: 'go-to-itunes',
    position: 'dashboard-subscription',
};

export const DASHBOARD__LINK__GO_TO_GOOGLEPLAY = {
    type: 'link',
    context: '',
    name: 'go-to-googleplay',
    position: 'dashboard-subscription',
};

export const DASHBOARD__LINK__CONTACT_US = {
    type: 'link',
    context: '',
    name: 'contact-us',
    position: 'dashboard-footer',
};

export const PAYMENT_METHOD__BUTTON__EDIT_INFO = {
    type: 'button',
    context: '',
    name: 'update-payment-info',
    position: 'payment-method',
};

export const USER_AVATAR__BUTTON__EDIT_AVATAR = {
    type: 'button',
    context: '',
    name: 'change-profile-picture',
    position: 'dashboard-user-data',
};

export const USER_FORM__BUTTON__ADVANCE_SETTINGS = {
    type: 'button',
    context: '',
    name: 'advance-settings',
    position: 'dashboard-user-data',
};

export const USER_FORM__LINK__DELETE_ACCOUNT = {
    type: 'link',
    context: '',
    name: 'delete-account',
    position: 'dashboard-user-data-advanced',
};

export const USER_FORM__BUTTON__CONNECT_FACEBOOK = {
    type: 'button',
    context: '',
    name: 'connect-facebook',
    position: 'dashboard-user-data-advanced',
};

export const USER_FORM__BUTTON__DISCONNECT_FACEBOOK = {
    type: 'button',
    context: '',
    name: 'disconnect-facebook',
    position: 'dashboard-user-data-advanced',
};

export const USER_FORM__BUTTON__DOWNLOAD_DATA = {
    type: 'button',
    context: '',
    name: 'download-data',
    position: 'dashboard-user-data-advanced',
};

export const USER_FORM__BUTTON__SAVE_CHANGES = {
    type: 'button',
    context: '',
    name: 'save-changes',
    position: 'dashboard-user-data',
};

export const DASHBOARD__BUTTON__SEE_PLANS = {
    type: 'button',
    context: '',
    name: 'see-plans',
    position: 'dashboard-banner',
};

export const DASHBOARD__BUTTON__BANNER_SUBSCRIBE = {
    type: 'button',
    context: '',
    name: 'subscribe',
    position: 'dashboard-banner',
};

export const PLANS_SWITCH__BUTTON__TOGGLE_PERIOD = {
    type: 'button',
    context: 'monthly,yearly',
    position: 'plans-selector',
};

export const PLANS_LIST__BUTTON__SELECT_PLAN = {
    type: 'button',
    position: 'plans-list',
};

export const PLANS_CHECKOUT__LINK__SEE_ALL = {
    type: 'link',
    context: '',
    name: 'see-all-plans',
    position: 'plans-checkout-form',
};

export const PLANS_CHECKOUT__LINK__CHANGE_PAYMENT_METHOD = {
    type: 'link',
    context: '',
    name: 'change-payment-method',
    position: 'plans-checkout-form',
};

export const PLAN_BUTTONS__BUTTON__SELECT_PLAN = {
    type: 'button',
    position: 'plan-buttons-sidebar',
};

export const DELETE_ACCOUNT__BUTTON__CONFIRM = {
    type: 'button',
    context: 'cancel,delete-account',
    position: 'delete-your-account-permanently-popup',
    name: 'delete-account',
};

export const DELETE_ACCOUNT__BUTTON__CANCEL = {
    type: 'button',
    context: 'cancel,delete-account',
    position: 'delete-your-account-permanently-popup',
    name: 'cancel',
};

export const DASHBOARD__BTN__LOGOUT_ALL_DEVICES = {
    type: 'button',
    context: '',
    position: 'dashboard-user-advanced',
    name: 'logout-all-devices',
};

export const DASHBOARD__LINK__REMOVE_FAMILY_MEMBER = {
    type: 'link',
    context: '',
    name: 'remove-family-member',
    position: 'dashboard-family',
};

export const DASHBOARD__LINK__ADD_FAMILY_MEMBER = {
    type: 'link',
    context: '',
    name: 'add-family-member',
    position: 'dashboard-family',
};

export const SUCCESS__PURCHASE__ADD_FAMILY_MEMBER = {
    type: 'button',
    context: '',
    name: 'add-family-member',
    position: 'success-purchase-page',
};

export const DASHBOARD__LINK__LEAVE_FAMILY = {
    type: 'link',
    context: '',
    name: 'leave-family',
    position: 'dashboard-family',
};

// this is legacy, now all the tracking can be done from gtm itself
export const gtagBackToSchoolPurchase = 'xRdvCKbUqqgBEPWX3LcD';

export const trackingEvent = 'tracking_event';
